/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Open_Screen_IntakeInputs */

const en_us2_chat_open_screen_intake = /** @type {(inputs: Chat_Open_Screen_IntakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer the intake`)
};

const pt_br2_chat_open_screen_intake = /** @type {(inputs: Chat_Open_Screen_IntakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responder o questionário`)
};

const es_419_chat_open_screen_intake = /** @type {(inputs: Chat_Open_Screen_IntakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responder el cuestionario`)
};

const pt_pt2_chat_open_screen_intake = /** @type {(inputs: Chat_Open_Screen_IntakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responder ao questionário`)
};

const fr_fr2_chat_open_screen_intake = /** @type {(inputs: Chat_Open_Screen_IntakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répondre au questionnaire`)
};

const de_de2_chat_open_screen_intake = /** @type {(inputs: Chat_Open_Screen_IntakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragebogen ausfüllen`)
};

const it_it2_chat_open_screen_intake = /** @type {(inputs: Chat_Open_Screen_IntakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rispondi al questionario`)
};

/**
* | output |
* | --- |
* | "Answer the intake" |
*
* @param {Chat_Open_Screen_IntakeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const chat_open_screen_intake = /** @type {((inputs?: Chat_Open_Screen_IntakeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Open_Screen_IntakeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_chat_open_screen_intake(inputs)
	if (locale === "es-419") return es_419_chat_open_screen_intake(inputs)
	if (locale === "pt-PT") return pt_pt2_chat_open_screen_intake(inputs)
	if (locale === "fr-FR") return fr_fr2_chat_open_screen_intake(inputs)
	if (locale === "de-DE") return de_de2_chat_open_screen_intake(inputs)
	if (locale === "it-IT") return it_it2_chat_open_screen_intake(inputs)
	return en_us2_chat_open_screen_intake(inputs)
});
export { chat_open_screen_intake as "chat.open_screen.intake" }